module.exports = __webpack_public_path__ + "/bundle/asset/U1_03-8bb7687056d9cabc55094ba55d1105c6.gif";